import EntityTable from "@mirage/components/entityTable/EntityTable";
import LinkCell from "@mirage/components/entityTable/components/LinkCell";
import { Box } from "@mui/system";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { IBcApplication } from "@shared/publicportal/entities/IBcApplication";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import React, { memo, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { SearchResultTableProps } from "./PlanningApplicationsTable";
import BuildingRegulationsService from "@publicPortal/services/BuildingRegulationsService";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";

const pp = new PublicPortalRoutingService();
const bcService = new BuildingRegulationsService();

const BuildingRegulationsTable: React.FC<SearchResultTableProps> = memo(({ filter, title, customPageRequest }) => {
    const navigate = useNavigate();
    const columns = useMemo(() => {
        return [
            {
                field: "name",
                headerName: "Reference",
                renderCell: (params: GridRenderCellParams) => <LinkCell value={params.value} route={pp.BuildingRegulationsRecordRoute(Number(params.id))} />,
                flex: 0.25,
            },
            { field: "finalProposal", headerName: "Final Proposal", flex: 1 },
            { field: "validationDate", headerName: "Validation Date", flex: 0.25, type: "date" },
            { field: "decision", headerName: "Decision", flex: 0.25 },
            { field: "status", headerName: "Status", flex: 0.25 },
            { field: "completedDate", headerName: "Completion Date", flex: 0.25, type: "date" },
        ];
    }, []);
    const onRecordSelected = useCallback(
        (record: IBcApplication) => {
            navigate(pp.BuildingRegulationsRecordRoute(record.id));
        },
        [navigate]
    );
    const pageRequest = useCallback(
        async (pageRequest: IEntityPageRequest) => {
            if (customPageRequest) {
                return await customPageRequest(pageRequest);
            }
            const response = await bcService.pageRequest(pageRequest);
            return response;
        },
        [customPageRequest]
    );

    return (
        <Box sx={{ marginTop: "32px", height: "auto" }}>
            <EntityTable
                title={title}
                key="building-regulations-entityTable"
                stateKey="bcRegulations"
                onPageRequest={pageRequest}
                columns={columns}
                filter={filter}
                onRecordSelected={onRecordSelected}
            />
        </Box>
    );
});

export default BuildingRegulationsTable;
